import { registerRoutingKey } from "Common/routingUtils";
import locale from "./routesMap.locale";
export default {
    PROJECT_DETAILS: registerRoutingKey("PROJECT_DETAILS")
};
const AREA_TITLE = locale.PROJECT_DETAILS;
export { AREA_TITLE };
